export const MatchSceneStatus = {
    NotStarted: 0,
    FirstHalf: 10,
    OneHalf: 11,
    OneHalfEnd: 12,
    TwoHalf: 13,
    TwoHalfEnd: 14,
    Halftime: 20,
    SecondHalf: 30,
    ThreeHalf: 31,
    ThreeHalfEnd: 32,
    FourHalf: 33,
    ExtraTime: 40,
    Penalties: 41,
    Ended: 50,
    Delayed: 60,
    Interrupted: 61,
    Abandoned: 62,
    Extension: 63,
    Cancelled: 64,
    ToBeDetermined: 99,

    CricketStatus: {
        Scheduled: 1,
        Completed: 2,
        Live: 3,
        Other: 4,
    },
};

export const MatchSceneName = {
    50: 'Ended',
    60: 'Delayed',
    61: 'Interrupted',
    62: 'Abandoned',
    63: 'Extension',
    64: 'Cancelled',
    99: 'TBD',
};

export const TodayMatchSortedRule = [
    // 目前 saba 排序實際情況：
    // 1. Live 2. 剛完賽沒多久 3. NotStarted (deadball) 4. 完賽 5 小時以上 5. 待定、延遲、取消
    // 目前排序需求
    // 1. Live: 1~49
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49,
    // 2. Deadball: === 0
    0,
    // 3. FullTime: === 50
    50,
    // 4. Other: 51~99
    51, 52, 53, 54, 55, 56, 57, 58, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
    71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    91, 92, 93, 94, 95, 96, 97, 98, 99,
];

export const CricketSortedRule = [3, 1, 2, 4];

export const sportList = [
    { sportName: 'Soccer', sportType: 1, i18nKey: 'lbl_Soccer' },
    { sportName: 'Basketball', sportType: 2, i18nKey: 'lbl_basketball' },
    // { sportName: 'Tennis', sportType: 5, i18nKey: 'lbl_Tennis', },
    // { sportName: 'Cricket', sportType: 50, i18nKey: 'lbl_Cricket' },
];

export const LiveScoreDisplayCount = 10;

export const LiveScoreStreamingFetchCount = 15;
